import React, { useState } from 'react';
import styles from './JobBoardPolicyModal.module.scss';

interface JobBoardPolicyModalProps {
  isOpen: boolean;
  onAgree: () => void;
  onClose: () => void;
}

const JobBoardPolicyModal: React.FC<JobBoardPolicyModalProps> = ({ isOpen, onAgree, onClose }) => {
  const [agreed, setAgreed] = useState(false);
  const [showError, setShowError] = useState(false);

  if (!isOpen) return null;

  const handleContinue = () => {
    if (!agreed) {
      setShowError(true);
      return;
    }
    onAgree();
  };

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.modal} role="dialog" aria-modal="true">
        <div className={styles.modalContent}>
          <h2 className={styles.modalTitle}>Job Board Policy</h2>
          <div className={styles.modalText}>
            <p>
              Our Job Board is a game-changer for finding great permanent and contract dental professionals to grow your team.
              But remember - this is only for permanent and long-term positions. Our policy strictly prohibits use of the Job Board to arrange temping shifts.
              For our fast/easy temping, click "Get a Temp" from the home calendar screen.
            </p>
          </div>
          <label className={styles.agreeRow}>
            <input type="checkbox" checked={agreed} onChange={(e) => { setAgreed(e.target.checked); setShowError(false); }} />
            <span>I Agree</span>
          </label>
          {showError && <div className={styles.errorText}>Please agree to proceed.</div>}
          <div className={styles.modalActions}>
            <button className={styles.cancelButton} onClick={onClose}>Go Back</button>
            <button className={styles.confirmButton} onClick={handleContinue}>Continue</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobBoardPolicyModal;


